import React, { useState } from "react";
import { Box, IconButton, Paper, Typography, makeStyles } from "@material-ui/core";
import {
  AvailabilityCalendarEvent,
  Color,
  DragNSelectCalendar,
  ExpandIcon
} from "@bonliva-crm/ui";
import { Overlay } from "@common";
import { removeTimezoneOffset } from "@bonliva-crm/common";
import { ExpandedViewModal } from "./components/expanded-view-modal";
import { useLocale } from "@hooks";

type Props = {
  label?: React.ReactNode;
  onSelectWeeks?: (value: Date[]) => void;
  preSelectedDates?: AvailabilityCalendarEvent[];
  keepSelected?: boolean;
  initialDate?: Date;
  hideExpandedView?: boolean;
  disabled?: boolean;
  error?: boolean;
};

export const WeekSelectorCalendar = (props: Props) => {
  const classes = useStyles({ error: props.error ?? false });
  const [showExpandedView, setShowExpandedView] = useState(false);
  const { locale } = useLocale();

  const onDateSelection = (weeks: Date[]) => {
    const weeksUtc = weeks?.map((x) => removeTimezoneOffset(x)) || [];

    if (props.onSelectWeeks) {
      props.onSelectWeeks(weeksUtc);
      return;
    }
  };

  return (
    <Paper className={classes.paper} style={{ position: "relative" }}>
      <Overlay in={props.disabled} normal />

      <Box className={classes.topWrapper}>
        <Typography className={classes.title}>{props.label ?? locale.Weeks}</Typography>
        {!props.hideExpandedView && (
          <IconButton onClick={() => setShowExpandedView(!showExpandedView)}>
            <ExpandIcon
              style={{
                marginTop: "4px"
              }}
            />
          </IconButton>
        )}
      </Box>

      <Box className={classes.calendarWrapper}>
        <DragNSelectCalendar
          keepSelected={props.keepSelected}
          upcomingWorkplaces={[]} // fix later
          preSelectedDates={props.preSelectedDates ?? []}
          initialDate={props.initialDate}
          onSelect={onDateSelection}
        />
        {/*<ColorDescription />*/}
      </Box>

      <ExpandedViewModal
        open={showExpandedView}
        onClose={() => setShowExpandedView(false)}
        onSelect={onDateSelection}
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  paper: {
    marginBottom: "1rem",
    height: "fit-content",
    paddingBottom: "1rem",
    width: "100%",
    boxShadow: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  topWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%",
    padding: "8 0"
  },
  title: (props: { error: boolean }) => ({
    textTransform: "uppercase",
    color: props.error ? Color.Error : Color.LightGray
  }),
  calendarWrapper: (props: { error: boolean }) => ({
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    border: `1px solid ${props.error ? Color.Error : Color.LightGray}`,
    borderRadius: "2px"
  })
}));
